import React from 'react';
import { Outlet } from 'react-router-dom';
import useLoadUserSession from './useLoadUserSession';

const UnauthenticatedLayoutPage = function UnauthenticatedLayoutPage() {
  const loadUserSession = useLoadUserSession();

  return <Outlet context={{ onLogin: () => loadUserSession() }} />;
};

export default UnauthenticatedLayoutPage;
